<template>
	<!-- Skip Link for Keyboard Navigation — teleported before v-main for first-focus order -->
	<Teleport to="#skip-links-portal">
		<a href="#main-content" class="skip-link" @click.prevent="() => { const el = document.getElementById('main-content'); if (el) el.focus(); }">Skip to main content</a>
	</Teleport>
    <div id="main-content" tabindex="-1" role="main" aria-label="RISE Distributor Dashboard">

        <header class="d-flex justify-center align-center w-100 position-relative" role="banner" aria-label="RISE Distributor Program Banner">
			<v-img class="w-100 h-100"		
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
				alt="RISE Distributor Program welcome banner"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Welcome to RISE" /></h1>
				<span><LanguagePlaceholder default-text="Elevate your rewards with every purchase" /></span>
			</div>			
		</header>
        <div class="d-flex justify-center align-center w-100 position-relative">
        </div>
        <section class="d-flex justify-center align-center w-100 position-relative" role="region" aria-label="Program information section">
            <div class="bg-color-quartz w-100 h-100" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 bg-color-teal-900 tx-color-white">
                    <!-- <v-col cols="1" class="d-flex flex-column justify-start w-100 pa-0 tx-font-normal tx-font-size20">
                    <v-img class="d-flex justify-center align-center"
                        @click="systemStore.openUrl('https://events.teams.microsoft.com/event/5f788fd7-522f-4ac1-86b5-3934cfb2e027@2a99324c-cc0e-4c71-bd89-39ea069a6c74')"
                        src="https://dellpartnerincentives.com/siteassets/Images/HomeDistributor/739114 RISE FY26Q4 - Webinar Banner Disti.jpg">
                    </v-img>
                    </v-col> -->
                    <v-col cols="9" class="d-flex flex-column justify-start w-100 pa-0 py-8 ps-4 tx-font-normal tx-font-size20">  
                        <!-- <v-row no-gutters>
                            <LanguagePlaceholder class="text-h4" default-text='Welcome to the RISE incentive program from Dell Technologies.' />
                        </v-row> -->

                        <v-row no-gutters class="text-body-3 my-0 align-center">
                            <div><LanguagePlaceholder default-text='This portal contains the information and assets you need to drive incremental business through Dell Technologies Authorized Partners.' />
                                <br></br>
                                <br></br>
                            <LanguagePlaceholder default-text='Sales data is loaded two weeks in arrears. Information such as the number of partners that purchase from you who are signed up to RISE will show after Week Two of the incentive period (when sales data is loaded).' /></div>
                            
                        </v-row>           
                    </v-col>
                </v-row>
            </div>
		</section>
        <section class="pa-4 mt-3" role="region" aria-label="Dashboard controls and filters">
            <v-container fluid class="pa-4">
            
            <v-row justify="center">
                        
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <!-- <v-container class="pb-0 bg-color-teal-700">
                        <v-sheet class="my-2 text-h4 font-weight-light bg-color-teal-700">
                            <h1 style="color: white; font-weight: 300;" class="text-h4 bg-color-teal-700"><LanguagePlaceholder default-text="Welcome to the RISE incentive program from Dell Technologies." /></h1>
                        </v-sheet>
                        <v-sheet class="my-2 text-body-2 font-weight-light bg-color-teal-700" style="color: white;">
                            <LanguagePlaceholder default-text="This portal contains the information and assets you need to drive incremental business through Dell Technologies' Authorized Partners." />
                        </v-sheet>
                        <v-sheet class="text-body-2 font-weight-light font-italic bg-color-teal-700" style="color: white;">
                            <LanguagePlaceholder default-text="Sales data is loaded two weeks in arrears. Information such as the number of partners that purchase from you who are signed up to RISE will show after Week Two of the incentive period (when sales data is loaded)." />
                        </v-sheet>
                    </v-container> -->
                </v-col>
                <v-col cols="0" sm="2"></v-col>
            </v-row>
            <v-row class="mt-5" no-gutters="" justify="center">
                <v-col cols="12" sm="4" md="6" class="pa-4">
                    <div>
                        <v-select v-model="selectedQuarter" :items="quarters"
                            @update:modelValue="changeQuarter"
                            @keydown.enter.stop.prevent
                            variant="outlined"
                            label="Select Incentive Period"
                            :aria-describedby="'quarter-help'"
                            id="quarter-select">
                            <template v-slot:label>
                                <LanguagePlaceholder default-text="Select Incentive Period" />
                            </template>
                        </v-select>
                        <div id="quarter-help" class="sr-only">
                            <LanguagePlaceholder default-text="Choose the incentive period to view dashboard data" />
                        </div>        
                    </div>
                    <fieldset v-if="showCountryAndDistributorSelection" role="group" aria-label="Distributor selection options" class="pa-4 mt-4">
                        <v-switch 
                            v-model="selectAll"
                            @update:modelValue="selectionChangeAll"
                            color="primary"
                            density="compact"
                            role="switch"
                            :aria-checked="selectAll"
                            aria-label="Select All Distributors in All Locations"
                            id="select-all-switch">
                            <template v-slot:label>
                                <LanguagePlaceholder default-text="Select All Distributors in All Locations" />
                            </template>
                        </v-switch>
                        <div v-if="!selectAll">
                            <div class="d-flex ga-5">
                                <v-switch 
                                    v-model="selectDistributorByRegion"
                                    @update:modelValue="selectionChangeDistributorByRegion"
                                    color="primary"
                                    density="compact"
                                    role="switch"
                                    :aria-checked="selectDistributorByRegion"
                                    aria-label="Select All Distributors by Region"
                                    id="select-by-region-switch">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select All Distributors by Region" />
                                    </template>
                                </v-switch>
                                <v-select :clearable="!!selectedRegion && selectDistributorByRegion" :items="regions"
                                    return-object v-model="selectedRegion"
                                    @keydown.enter.stop.prevent
                                    variant="outlined"
                                    label="Select Region"
                                    :disabled="!selectDistributorByRegion"
                                    id="region-select">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select All Distributors by Region" />
                                    </template>
                                </v-select> 
                            </div>
                            <div class="d-flex ga-5">
                                <v-switch 
                                    v-model="selectDistributorByCountry"
                                    @update:modelValue="selectionChangeDistributorByCountry"
                                    color="primary"
                                    density="compact"
                                    role="switch"
                                    :aria-checked="selectDistributorByCountry"
                                    aria-label="Select Distributors by Location"
                                    id="select-by-country-switch">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select Distributors by Location" />
                                    </template>
                                </v-switch>
                                <v-select :clearable="!!selectedCountry && selectDistributorByCountry" :items="countries"
                                    return-object v-model="selectedCountry"
                                    @update:modelValue="changeCountry" item-title="country" item-value="country"
                                    @keydown.enter.stop.prevent
                                    variant="outlined"
                                    label="Select Location"
                                    :disabled="!selectDistributorByCountry"
                                    id="country-select">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select Distributors by Location" />
                                    </template>
                                </v-select> 
                                <v-select
                                    :clearable="!!selectedDistributor && selectDistributorByCountry"
                                    v-model="selectedDistributor" return-object
                                    item-title="distributorName"
                                    item-value="distiId" :items="distributors" variant="outlined"
                                    label="Select Distributor"
                                    :disabled="!selectDistributorByCountry"
                                    id="distributor-select">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select Distributor" />
                                    </template>
                                </v-select> 
                            </div> 
                            <div class="d-flex ga-5">
                                <v-switch 
                                    v-model="selectMasterDistributor"
                                    @update:modelValue="selectionChangeMasterDistributor"
                                    color="primary"
                                    density="compact"
                                    role="switch"
                                    :aria-checked="selectMasterDistributor"
                                    aria-label="Select Distributor in All Locations"
                                    id="select-master-distributor-switch">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select Distributor in All Locations" />
                                    </template>
                                </v-switch>
                                <v-select
                                    :clearable="!!selectedMasterDistributor && selectMasterDistributor"
                                    v-model="selectedMasterDistributor" return-object
                                    @keydown.enter.stop.prevent
                                    item-title="distributorName"
                                    item-value="distributorName" :items="masterDistributors" variant="outlined"
                                    label="Select Distributor in All Locations"
                                    :disabled="!selectMasterDistributor"
                                    id="master-distributor-select">
                                    <template v-slot:label>
                                        <LanguagePlaceholder default-text="Select Distributor in All Locations" />
                                    </template>
                                </v-select> 
                            </div>                                
                        </div>                        
                    </fieldset>
                </v-col>
            </v-row>
            <v-row  no-gutters="" justify="center" class="pa-4"> 
                <div>
                    <v-btn @click="getData" @keydown.enter="getData" @keydown.space.prevent="getData"
                        variant="outlined" aria-label="Submit form to load dashboard data" tabindex="0" id="submit-btn"><LanguagePlaceholder default-text="Submit" />
                    </v-btn>
                </div>
            </v-row>
            <v-row justify="center">
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <v-container class="pt-0" data-dashboard-results>
                        <section v-for="o, idx in dashboardItems" class="animate__animated animate__fadeInBottomLeft animate__faster" :key="idx" role="region" :aria-label="`${o.category} dashboard section`">
                            <v-sheet class="my-2 text-body-2 font-weight-bold" color="transparent" style="color: white;">
                                <h2 style="color: #000c30; font-weight: 300;" class="text-h5"><LanguagePlaceholder :default-text="o.category" /></h2>
                            </v-sheet>
                            <v-row>
                                <v-col cols="12" sm="12" md="4"  v-for="oItm, idxItm in o.items" :key="idxItm">
                                    <v-card tile :color="oItm.bgColor" style="height: 150px;">
                                        <v-card-text class="ma-3 pa-0">
                                            <v-sheet class="my-2 text-body-2 font-weight-regular" color="transparent"
                                                style="color: white;" height="40">
                                                <h3><LanguagePlaceholder :default-text="oItm.header" /></h3>
                                            </v-sheet>
                                            <v-sheet v-if="oItm.isCurrency === true" class="my-2 text-h5 font-weight-bold" color="transparent"
                                                style="color: white;">
                                                {{ $filters.currencyUSD(oItm.value) }}
                                            </v-sheet>
                                            <v-sheet v-if="oItm.isNumber === true" class="my-2 text-h5 font-weight-bold" color="transparent"
                                                style="color: white;">
                                                {{ $filters.formattedNumber(oItm.value) }}
                                            </v-sheet>
                                            <v-btn 
                                            class="text-none" 
                                            style="color: black; position: absolute; bottom: 5px; width: 93%;" 
                                            @click="oItm.clickEvent" @keydown.enter="oItm.clickEvent" @keydown.space.prevent="oItm.clickEvent"
                                            :aria-label="oItm.buttonText" tabindex="0"
                                            role="link">
                                                <LanguagePlaceholder :default-text="oItm.buttonText" />
                                                </v-btn>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </section>                        
                    </v-container>
                </v-col>
                <v-col cols="0" sm="2"></v-col>
            </v-row>
            </v-container>
        </section>
    </div>

</template>

<script setup>
import { ref, onMounted, watch, onBeforeUnmount, nextTick } from 'vue'
import { useSystemStore } from '@/stores/system'
import { useExcelStore } from '@/stores/excel'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()
const excelStore = useExcelStore()

const timeout = 3000;

// Focus restoration
let lastFocusedElement = null
const FOCUS_STORAGE_KEY = 'homeDistributor_lastFocusedElement'

const dashboardItems = ref([])
const reportData = ref({})

const quarters = ref([])
const selectedQuarter = ref('')

const countries = ref([])
const selectedCountry = ref('')

const regions = ref([])
const selectedRegion = ref('')

const distributors = ref([])
const selectedDistributor = ref('')

const masterDistributors = ref([])
const selectedMasterDistributor = ref('')
const selectMasterDistributor = ref(false)

const showCountryAndDistributorSelection = ref(false)
const selectAll = ref(false)
const selectDistributorByCountry = ref(false)
const selectDistributorByRegion = ref(false)

// Focus tracking functions
const trackFocus = (event) => {
    if (event.target && event.target !== document.body) {
        lastFocusedElement = event.target
        const closestWithId = event.target.closest?.('[id]')
        const stableId = event.target.id || closestWithId?.id

        // Store the element's identifier for restoration
        const elementId = stableId ||
                         event.target.getAttribute('aria-label') ||
                         event.target.className ||
                         event.target.tagName
        sessionStorage.setItem(FOCUS_STORAGE_KEY, elementId)
    }
}

const focusAfterSelection = (controlId) => {
    // v-select often teleports menu content; refocus the control (or its input) after updates.
    setTimeout(() => {
        try {
            const root = document.getElementById(controlId)
            if (!root) return

            const focusTarget =
                root.matches?.('input,button,select,textarea,[tabindex]') ? root :
                root.querySelector?.('input:not([disabled])') ||
                root.querySelector?.('button:not([disabled])') ||
                root.querySelector?.('[tabindex="0"]') ||
                root

            if (focusTarget && typeof focusTarget.focus === 'function') {
                focusTarget.focus()
            }
        } catch (error) {
            console.log('Focus restore after selection failed:', error)
        }
    }, 50)
}

const getFocusableElements = () => {
    const selector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',')

    return Array.from(document.querySelectorAll(selector)).filter((el) => {
        if (!(el instanceof HTMLElement)) return false
        if (el.getAttribute('aria-hidden') === 'true') return false
        // Visible check
        return el.offsetParent !== null || el.getClientRects().length > 0
    })
}

const findFocusableAncestorInList = (el, list) => {
    let current = el
    while (current && current instanceof HTMLElement) {
        if (list.includes(current)) return current
        current = current.parentElement
    }
    return null
}

const handleTabWhenFocusLost = (event) => {
    if (event.key !== 'Tab') return

    const active = document.activeElement
    const focusLost = active === document.body || active === document.documentElement || active == null
    if (!focusLost) return
    if (!lastFocusedElement) return

    const focusables = getFocusableElements()
    if (focusables.length === 0) return

    // If the last focused element was a teleported menu item (removed), fall back to stored ID.
    let from = lastFocusedElement?.isConnected ? lastFocusedElement : null
    if (!from) {
        const stored = sessionStorage.getItem(FOCUS_STORAGE_KEY)
        if (stored) {
            from = document.getElementById(stored) || document.querySelector(`[aria-label="${stored}"]`)
        }
    }
    if (!from) return

    const focusFrom = findFocusableAncestorInList(from, focusables) || from
    const idx = focusables.indexOf(focusFrom)
    if (idx === -1) return

    const nextIdx = event.shiftKey ? idx - 1 : idx + 1
    if (nextIdx < 0 || nextIdx >= focusables.length) return

    event.preventDefault()
    focusables[nextIdx].focus()
}

const restoreFocus = () => {
    const storedElementId = sessionStorage.getItem(FOCUS_STORAGE_KEY)
    if (storedElementId) {
        // Try to find the element by ID first
        let element = document.getElementById(storedElementId)
        
        // If not found by ID, try to find by aria-label
        if (!element) {
            element = document.querySelector(`[aria-label="${storedElementId}"]`)
        }
        
        // If still not found, try to find by class name
        if (!element) {
            element = document.querySelector(`.${storedElementId}`)
        }
        
        // If found and focusable, restore focus
        if (element && element.focus && typeof element.focus === 'function') {
            // Use setTimeout to ensure DOM is fully rendered
            setTimeout(() => {
                try {
                    element.focus()
                } catch (error) {
                    console.log('Focus restoration failed:', error)
                }
            }, 100)
        }
        
        // Clear the stored value after attempting restoration
        sessionStorage.removeItem(FOCUS_STORAGE_KEY)
    }
}

const selectionChangeAll = () => {
    if (selectAll.value === true) {
        selectDistributorByCountry.value = false
        selectDistributorByRegion.value = false
        selectMasterDistributor.value = false
        
        selectedDistributor.value = ''
        selectedCountry.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }
    else {
        if (selectDistributorByCountry.value === false && selectDistributorByRegion.value === false && selectMasterDistributor.value === false) {
            selectDistributorByCountry.value = true
        }
    }
}

const newsArticlesDisti = ref([
      { backgroundColor: "#84133f", heading: 'Find out what\'s new in RISE!'
      , subHeading: 'Sign up for the Webinar!'
      , pictureUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/RISEDistiWebinar.jpg'
      , readMoreContentUrl: 'https://www.dellpartnerincentives.com/siteassets/Images/News/RISEDistiWebinar.html', clickEvent: undefined },
])

const clickReadMore = (o) => {
    if (o.clickEvent !== undefined) {
        o.clickEvent()
    } else {
        systemStore.openUrl(o.readMoreContentUrl)
    }
}

const selectionChangeDistributorByCountry = () => {
    if (selectDistributorByCountry.value === true) {
        selectAll.value = false
        selectDistributorByRegion.value = false
        selectMasterDistributor.value = false
       
        selectedDistributor.value = ''
        selectedCountry.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }
    else {
        if (selectAll.value === false && selectDistributorByRegion.value === false && selectMasterDistributor.value === false) {
            selectDistributorByCountry.value = true
        }
    }
}

const selectionChangeMasterDistributor = () => {
    if (selectMasterDistributor.value === true) {
        selectAll.value = false
        selectDistributorByRegion.value = false
        selectDistributorByCountry.value = false

        selectedDistributor.value = ''
        selectedCountry.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }
    else {
        if (selectAll.value === false && selectDistributorByRegion.value === false && selectMasterDistributor.value === false) {
            selectDistributorByCountry.value = true
        }
    }
}

const selectionChangeDistributorByRegion = () => {
    if (selectDistributorByRegion.value === true) {
        selectAll.value = false
        selectDistributorByCountry.value = false
        selectMasterDistributor.value = false
        
        selectedDistributor.value = ''
        selectedCountry.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }
    else {
        if (selectDistributorByCountry.value === false && selectAll.value === false && selectMasterDistributor.value === false) {
            selectDistributorByCountry.value = true
        }
    }
}

const changeQuarter = () => {
    selectedDistributor.value = ''
    selectedCountry.value = ''
    selectedRegion.value = ''
    selectedMasterDistributor.value = ''
}

const changeCountry = () => {
    selectedDistributor.value = ''

    if (selectedCountry.value === null || selectedCountry.value === '') {
        return
    }

    systemStore.getPartnerPerformanceDistributors(selectedQuarter.value, selectedCountry.value).then(result => {
        distributors.value = result.responseData

        if (distributors.value.length === 1) {
            selectedDistributor.value = distributors.value[0]
        }

        // After loading distributors for a country, move focus to the next logical control.
        // This prevents focus dropping to <body> (which makes Tab jump to the top).
        if (selectDistributorByCountry.value === true) {
            focusAfterSelection('distributor-select')
        }
    }).catch(error => {
        console.log(error)
    })
}

onMounted(() => {
    // Add focus tracking event listener
    document.addEventListener('focusin', trackFocus)
    document.addEventListener('keydown', handleTabWhenFocusLost, true)
    
    // Restore focus after a short delay to ensure DOM is ready
    setTimeout(restoreFocus, 200)
    
    if (systemStore.userDetail.userType.trim() === 'TIC_Admin' || 
        systemStore.userDetail.userType.trim() === 'Dell Marketing') {
        showCountryAndDistributorSelection.value = true
        selectDistributorByCountry.value = true
    }

    systemStore.getQuarters().then(result => {
        if (result.success) {
            quarters.value = result.quarters
                .filter(q => q.currentQuarter === true || q.currentRedemptionQuarter === true)
                .map(q => q.quarter)

            selectedQuarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter

            if (showCountryAndDistributorSelection.value === true) {
                systemStore.getPartnerPerformanceCountries(selectedQuarter.value).then(result => {
                    countries.value = result.responseData
                    selectedCountry.value = ''
                })        

                systemStore.getPartnerPerformanceRegions().then(result => {
                    regions.value = result.responseData
                    selectedCountry.value = ''
                })    

                systemStore.getPartnerPerformanceMasterDistributors().then(result => {
                    masterDistributors.value = result.responseData
                })

            }
            else {
                getData()
            }            
        }
    }).catch(error => {
        console.log('recalculateLocalValue', error)
    })    

})

onBeforeUnmount(() => {
    // Remove focus tracking event listener
    document.removeEventListener('focusin', trackFocus)
    document.removeEventListener('keydown', handleTabWhenFocusLost, true)
})

const getData = () => {
    if (showCountryAndDistributorSelection.value === true) { 
        if (selectDistributorByCountry.value === true) {
            selectedRegion.value = ''
            selectedMasterDistributor.value = ''
            if (selectedCountry.value === '') {
                systemStore.showMessage('Select a Location and/or Distributor', { timeout: timeout, color: 'info' })
                return
            }
            if (selectedDistributor.value === null) {
                selectedDistributor.value = ''
            }
        } else if (selectDistributorByRegion.value === true) {
            selectedCountry.value = ''
            selectedDistributor.value = ''
            selectedMasterDistributor.value = ''
            if (selectedRegion.value === '') {
                systemStore.showMessage('Select a Region', { timeout: timeout, color: 'info' })
                return
            }
        } else if (selectMasterDistributor.value === true) {
            selectedCountry.value = ''
            selectedDistributor.value = ''
            selectedRegion.value = ''
            if (selectedMasterDistributor.value === '') {
                systemStore.showMessage('Select a Distributor', { timeout: timeout, color: 'info' })
                return
            }
        } else if (selectAll.value === true) {
            selectedCountry.value = ''
            selectedDistributor.value = ''
            selectedRegion.value = ''
            selectedMasterDistributor.value = ''
        }
        else {
            if (selectedCountry.value === '') {
                systemStore.showMessage('Select a Location and/or Distributor', { timeout: timeout, color: 'info' })
                return
            }
        }
    }
    else {
        selectedCountry.value = ''
        selectedDistributor.value = ''
        selectedRegion.value = ''
        selectedMasterDistributor.value = ''
    }   

    systemStore.getDistributorHomeDashboard(selectedQuarter.value
        , selectedCountry.value
        , selectedDistributor.value === '' ? 0 : selectedDistributor.value.distiId
        , selectedRegion.value
        , selectedMasterDistributor.value).then(result => {
        reportData.value = result.responseData

        var onboarding = {'category': 'RISE Onboarding', items: []}

        onboarding.items.push({header: 'Your partners buying eligible products', bgColor: '#004D40', value: reportData.value.partnersBuyingEligibleProducts, isCurrency: false, isNumber: true, buttonText: 'Show Partner Performance', clickEvent: showPartnerPerformance})
        onboarding.items.push({header: 'Your partners signed up to RISE', bgColor: '#00796B', value: reportData.value.partnersSignedUpToRiseCount, isCurrency: false, isNumber: true, buttonText: 'Show Partners IN RISE', clickEvent: showPartnerInRise})
        onboarding.items.push({header: 'Your partners not signed up to RISE', bgColor: '#EEEEEE', value: reportData.value.partnersNotSignedUpToRiseCount, isCurrency: false, isNumber: true,  buttonText: 'Show Partners OUT of RISE', clickEvent: showPartnerOutOfRise})
        
        var riseEarnings = {'category': 'RISE Earnings', items: []}

        riseEarnings.items.push( {header: "Your partners' earnings this period", bgColor: "#004D40", value: reportData.value.partnersEarningsThisPeriod, isCurrency: true, buttonText: "Show Partner Performance", clickEvent: showPartnerPerformance})
        riseEarnings.items.push({header: "Your partners' earnings last period", bgColor: "#00796B", value: reportData.value.partnersEarningsLastPeriod, isCurrency: true, buttonText: "Show Partner Performance", clickEvent: showPartnerPerformance})
        riseEarnings.items.push({header: "Eligible partners' bonus reward value", bgColor: "#EEEEEE", value: reportData.value.partnerBonus, isCurrency: true, buttonText: "Show Bonus Dashboard", clickEvent: ShowBonusDashboard})

        var evouchers = {'category': 'E-Vouchers', items: []}

        evouchers.items.push({header: "Your partners with $ to redeem for e-vouchers", bgColor: "#004D40", value: reportData.value.partnersWithDollarRewardsToRedeemForEVouchers, isCurrency: false, buttonText: "Show Partner Performance", clickEvent: showPartnerPerformance})
        evouchers.items.push({header: "Your partners with e-vouchers to spend", bgColor: "#00796B", value: reportData.value.partnersWithEVouchersToSpend, isCurrency: false, buttonText: "Show E-Voucher Report", clickEvent: showEVoucherReport})
        evouchers.items.push({header: "Value of e-vouchers remaining to spend", bgColor: "#EEEEEE", value: reportData.value.valueOfEVouchersRemainingToSpend, isCurrency: true, buttonText: "Show E-Voucher Report", clickEvent: showEVoucherReport})

        var creditnotes = {'category': 'Credit Notes', items: []}

        creditnotes.items.push({header: "Your partners with credit notes to spend", bgColor: "#004D40", value: reportData.value.partnersWithCreditNotesToSpend, isCurrency: false, buttonText: "Show Credit Note Report", clickEvent: showCreditNoteReport})
        creditnotes.items.push({header: "Value of credit notes remaining to spend", bgColor: "#00796B", value: reportData.value.valueOfCreditNotesRemainingToSpend, isCurrency: true, buttonText: "Show Credit Note Report", clickEvent: showCreditNoteReport})

        dashboardItems.value = []
        dashboardItems.value.push(onboarding)
        dashboardItems.value.push(riseEarnings)
        dashboardItems.value.push(evouchers)
        dashboardItems.value.push(creditnotes)

        // Move focus to updated content after data loads (Issue #16)
        nextTick(() => {
            const firstSection = document.querySelector('[data-dashboard-results]')
            if (firstSection) {
                firstSection.setAttribute('tabindex', '-1')
                firstSection.focus()
            }
        })
    })
}

const downloadPartnersOutOfRiseFile = () => {
    if (reportData.value.length === 0) {
        return
    }
    
    excelStore.generateInMemoryExcelDocument(reportData.value.partnersNotSignedUpToRise, 'DistributorOutOfRisePartners').catch(error => {
        console.log('Generate In Memory Excel Document - DistributorOutOfRisePartners', error)
    })
}

const downloadPartnersInRiseFile = () => {
    if (reportData.value.length === 0) {
        return
    }
    
    excelStore.generateInMemoryExcelDocument(reportData.value.partnersSignedUpToRise, 'DistributorInRisePartners').catch(error => {
        console.log('Generate In Memory Excel Document - DistributorInRisePartners', error)
    })
}

const showPartnerPerformance = () => {
    systemStore.routerTo('partner-performance')
}

const ShowBonusDashboard = () => {
    systemStore.routerTo('bonus-dashboard-distributor')
}

const showPartnerInRise = () => {
    downloadPartnersInRiseFile()
}

const showPartnerOutOfRise = () => {
    downloadPartnersOutOfRiseFile()
}

const showEVoucherReport = () => {
    systemStore.routerTo('distributor-evoucher-report')
}
const showCreditNoteReport = () => {
    systemStore.routerTo('creditnote-report')
}


</script>

<style scoped>
    /*
      WCAG 2.0 Focus Indicators — dual-ring pattern:
        outer ring : #003785 dark navy (~13:1 vs white)
        inner halo : #FFFFFF white   (~8:1 vs dark toolbar #444444)
      Visible on both light and dark backgrounds.
    */
    :deep(.v-btn:focus-visible) {
        outline: 3px solid #003785 !important;
        outline-offset: 4px !important;
        box-shadow: 0 0 0 4px #FFFFFF !important;
        position: relative !important;
        z-index: 10 !important;
    }

    /*
      v-select: outer wrapper div is not natively focusable.
      Target .v-field using Vuetify's own focused class AND :focus-within fallback.
    */
    :deep(.v-select .v-field--focused),
    :deep(.v-select .v-field:focus-within) {
        outline: 3px solid #003785 !important;
        outline-offset: 2px !important;
        box-shadow: 0 0 0 2px #FFFFFF !important;
    }

    /*
      v-switch: inner <input type="checkbox"> is hidden.
      :has(input:focus-visible) targets keyboard-only focus reliably.
      :focus-within kept as fallback for older browsers.
    */
    :deep(.v-switch:has(input:focus-visible)),
    :deep(.v-switch:focus-within) {
        outline: 3px solid #003785 !important;
        outline-offset: 4px !important;
        box-shadow: 0 0 0 4px #FFFFFF !important;
        border-radius: 4px;
    }

    :deep(.v-card:focus-visible) {
        outline: 3px solid #003785 !important;
        outline-offset: 4px !important;
        box-shadow: 0 0 0 4px #FFFFFF !important;
    }

    /* High contrast mode support */
    @media (prefers-contrast: high) {
        :deep(.v-btn:focus-visible),
        :deep(.v-switch:has(input:focus-visible)),
        :deep(.v-switch:focus-within),
        :deep(.v-card:focus-visible) {
            outline-width: 4px !important;
            outline-color: #000000 !important;
            box-shadow: 0 0 0 4px #FFFFFF !important;
        }
    }

    /* Reduced motion support for animations */
    @media (prefers-reduced-motion: reduce) {
        .animate__animated {
            animation: none !important;
        }
    }

    /* Screen reader only content */
    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }

    /* WCAG 1.4.4 / 1.4.10 — Prevent content overlap and loss at 200%+ zoom */
    @media (max-width: 960px) {
        :deep(.d-flex.ga-5) {
            flex-direction: column !important;
            gap: 0.5rem !important;
        }
        :deep(.v-select) {
            width: 100% !important;
        }
        :deep(.pa-4) {
            padding: 0.5rem !important;
        }
    }

    @media (max-width: 599px) {
        :deep(.v-card) {
            min-width: 0;
            overflow-x: auto;
        }
        :deep(.v-data-table) {
            overflow-x: auto;
            display: block;
            width: 100%;
        }
    }
</style>